import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { avatarQueryKeys } from './constants'
import api from '../../config/axios-config'

export const useGetAvatarQuery = (avatarUrl, options) => {
  const [avatarObjectUrl, setAvatarObjectUrl] = useState(null)

  const handleQuery = async () => {
    const config = {
      method: 'get',
      responseType: 'blob',
      skipHeaders: true
    }

    const { data } = await api(avatarUrl, config)

    if (!data || data.size === 0) {
      return null
    }

    return data
  }

  const query = useQuery({
    queryKey: [avatarQueryKeys.AVATAR_IMAGE, avatarUrl],
    queryFn: handleQuery,
    enabled: !!avatarUrl,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    ...options
  })

  useEffect(() => {
    if (!query.data) {
      setAvatarObjectUrl(null)
      return
    }

    const objectUrl = URL.createObjectURL(query.data)
    setAvatarObjectUrl(objectUrl)

    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [query.data])

  return {
    ...query,
    data: avatarObjectUrl
  }
}
